var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

var HomeHero = function () {
	this.heroImg = $( document.querySelector( '#hero img' ) );
};

HomeHero.prototype.init = function () {
};

module.exports = new HomeHero();
